export enum OverseasStatusCodes {
  APPROVED = 1,
  CANCELLED,
  REJECTED,
  OPEN,
  AWAITING_APPROVAL_OF_HOD_PROJECT_MANAGER,
  AWAITING_APPROVAL_OF_HR_MANAGER,
  AWAITING_APPROVAL_OF_CEO_GM,
  AWAITING_APPROVAL_OF_PAYROLL_ADMIN,
  AWAITING_FOR_PROCESS,
}
